import * as types from '../actionsTypes/breadcrumbActionTypes';

export const updateBreadcrumb = (path) => {
    return {
        type: types.UPDATE_BREADCRUMB,
        path: path
    }
};
